// Formula parser. Grammar: "=" func "(" refList ")" where func is SUM/AVERAGE/COUNT
// and a ref is a cellRef or cellRef:cellRef. e.g. `=SUM(A1,B3:B5,C2)`.
import { colLettersToIndex, type Coord } from "./coord-translation";

export type FormulaFunc = "SUM" | "AVERAGE" | "COUNT";

export interface ParsedRange {
  start: Coord;
  end: Coord;
}

export type ParseResult =
  | { ok: true; func: FormulaFunc; refs: ParsedRange[] }
  | { ok: false; kind: "syntax" };

const SHELL_RE = /^=\s*(SUM|AVERAGE|COUNT)\s*\(\s*(.+?)\s*\)\s*$/i;
const REF_RE = /^([A-Z]+)([1-9][0-9]*)(?:\s*:\s*([A-Z]+)([1-9][0-9]*))?$/i;

export const parseFormula = (input: string): ParseResult => {
  if (!input) return { ok: false, kind: "syntax" };
  const shell = SHELL_RE.exec(input.trim());
  if (!shell) return { ok: false, kind: "syntax" };
  const func = shell[1].toUpperCase() as FormulaFunc;
  const argList = shell[2];

  const refs: ParsedRange[] = [];
  for (const segment of argList.split(",")) {
    const trimmed = segment.trim();
    if (!trimmed) return { ok: false, kind: "syntax" };
    const m = REF_RE.exec(trimmed);
    if (!m) return { ok: false, kind: "syntax" };
    const startCol = colLettersToIndex(m[1].toUpperCase());
    const startRow = parseInt(m[2], 10) - 1;
    const endCol = m[3] ? colLettersToIndex(m[3].toUpperCase()) : startCol;
    const endRow = m[4] ? parseInt(m[4], 10) - 1 : startRow;
    refs.push({
      start: { col: startCol, row: startRow },
      end: { col: endCol, row: endRow },
    });
  }

  if (refs.length === 0) return { ok: false, kind: "syntax" };
  return { ok: true, func, refs };
};
